module.exports = __webpack_public_path__ + "img/login_img.38e4587d.png";